import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-lmms',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>LMMS icon</title><path d="M1.714 0A1.71 1.71 0 000 1.714v20.572C0 23.236.765 24 1.714 24h20.572A1.71 1.71 0 0024 22.286V1.714A1.71 1.71 0 0022.286 0zM12 3l9 5.143v10.286l-3 1.714-3-1.714V15l3-1.714V9.857L12 6.43 6 9.857v3.429L9 15v3.429l-3 1.714-3-1.714V8.143Z"/></svg>`,
    styles: []
})
export class SimpleIconsLmmsComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#10B146';
    @Input() className: string = 'simple-icons-lmms'
    constructor() {}
    ngOnInit(): void {}
}
